import { createSlice } from '@reduxjs/toolkit';
import { createDLCForm, fetchDLCForm } from '../actions';

const initialState = {
  isLoading: true,
  isSuccess: false,
  blockNewCredits: false,
  tenDlcData: {
    siteName: '',
    businessPhysicalAddress: {
      country: '',
      streetAddress1: '',
      streetAddress2: '',
      city: '',
      state: '',
      postalCode: '',
    },
    businessType: '',
    businessIndustry: '',
    companyStatus: '',
    businessRegistrationType: '',
    businessRegistrationNumber: '',
    regionsOfOperations: [],
    website: '',
    socialMediaUrl: '',
    privacyPolicyUrl: '',
    termsAndConditionsUrl: '',
    peopleToContact: [
      {
        firstName: '',
        lastName: '',
        email: '',
        countryCode: '',
        phoneNumber: '',
        businessTitle: '',
        jobPosition: '',
      },
      {
        firstName: '',
        lastName: '',
        email: '',
        countryCode: '',
        phoneNumber: '',
        businessTitle: '',
        jobPosition: '',
      },
    ],
    campaignDescription: '',
    sampleMessage: '',
    messageFlow: '',
    stockTicker: '',
    stockExchange: '',
    brandRepresentativeEmail: '',
    requestToSubmit: false,
    acknowledgeCheck: false,
    disablePOC2: false,
    errorFields: [],
    enableEditForSubmittedForm: false,
    tenDlcErrors: [],
  },
};

const dlcFormSlice = createSlice({
  name: 'dlcForm',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(fetchDLCForm.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchDLCForm.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tenDlcData = action.payload.tenDlcRegistration;
      state.blockNewCredits = action.payload.blockNewCredits;
    });

    builder.addCase(fetchDLCForm.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(createDLCForm.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(createDLCForm.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tenDlcData = action.payload.tenDlcRegistration;
      state.blockNewCredits = action.payload.blockNewCredits;
      state.isSuccess = true;
    });

    builder.addCase(createDLCForm.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    });
  },
});

export default dlcFormSlice;
